import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../Style/Model.css';
import { BASE_URL } from "../Apis/apiConfig";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { X, Save, User, Briefcase, Mail, Phone, MapPin, Building2 } from 'lucide-react';

const Model = ({ employee, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    employeeId: '',
    employeeName: '',
    designation: '',
    email: '',
    phone: '',
    address: '',
    serviceName: '',
    companyName: '',
    role: '',
    usingApp: false,
    status: false,
  });

  useEffect(() => {
    if (employee) {
      setFormData(employee);
    }
  }, [employee]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    try {
      const societyName = localStorage.getItem("society");
      await axios.post(`${BASE_URL}/api/employee/update-employee`, null, {
        params: {
          employeeId: formData.employeeId,
          employeeName: formData.employeeName,
          designation: formData.designation,
          employeeEmail: formData.employeeEmail,
          employeePhone: formData.employeePhone,
          employeeAddress: formData.employeeAddress,
          serviceName: formData.serviceName,
          companyName: formData.companyName,
          role: formData.role,
          usingApp: formData.usingApp || false,
          status: formData.status || false,
          societyName: societyName,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success("Employee updated successfully!", {
        position: "bottom-right",
        autoClose: 3000,
      });
      if (onSave) onSave();
      onClose();
    } catch (error) {
      console.error(error);
      toast.error("Failed to update employee.", {
        position: "bottom-right",
        autoClose: 3000,
      });
    }
  };

  return (
    <div className="modal-overlay-modern" onClick={onClose}>
      <ToastContainer />
      <div className="modal-content-modern" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header-modern">
          <h2>Edit Employee</h2>
          <button className="modal-close-btn" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form-modern">
          <div className="modal-body-modern">
            <div className="form-grid-modal">
              <div className="form-field-modal">
                <label>
                  <User size={16} />
                  <span>Employee Name</span>
                </label>
                <input
                  name="employeeName"
                  value={formData.employeeName}
                  onChange={handleChange}
                  placeholder="Enter employee name"
                  required
                />
              </div>

              <div className="form-field-modal">
                <label>
                  <Briefcase size={16} />
                  <span>Designation</span>
                </label>
                <input
                  name="designation"
                  value={formData.designation}
                  onChange={handleChange}
                  placeholder="Enter designation"
                />
              </div>

              <div className="form-field-modal">
                <label>
                  <Mail size={16} />
                  <span>Email</span>
                </label>
                <input
                  name="email"
                  type="email"
                  value={formData.employeeEmail}
                  onChange={handleChange}
                  placeholder="Enter email"
                />
              </div>

              <div className="form-field-modal">
                <label>
                  <Phone size={16} />
                  <span>Phone</span>
                </label>
                <input
                  name="phone"
                  type="tel"
                  value={formData.employeePhone}
                  onChange={handleChange}
                  placeholder="Enter phone number"
                />
              </div>

              <div className="form-field-modal full-width-modal">
                <label>
                  <MapPin size={16} />
                  <span>Address</span>
                </label>
                <input
                  name="address"
                  value={formData.employeeAddress}
                  onChange={handleChange}
                  placeholder="Enter address"
                />
              </div>

              <div className="form-field-modal">
                <label>
                  <Building2 size={16} />
                  <span>Service Name</span>
                </label>
                <input
                  name="serviceName"
                  value={formData.serviceName}
                  onChange={handleChange}
                  placeholder="Enter service name"
                />
              </div>

              <div className="form-field-modal">
                <label>
                  <Building2 size={16} />
                  <span>Company Name</span>
                </label>
                <input
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                  placeholder="Enter company name"
                />
              </div>

              <div className="form-field-modal">
                <label>
                  <Briefcase size={16} />
                  <span>Role</span>
                </label>
                <input
                  name="role"
                  value={formData.role}
                  onChange={handleChange}
                  placeholder="Enter role"
                />
              </div>
            </div>

            <div className="toggle-section-modal">
              <div className="toggle-item-modal">
                <div className="toggle-label-group">
                  <span className="toggle-label-text">Using App</span>
                  <span className="toggle-status">{formData.usingApp ? 'Yes' : 'No'}</span>
                </div>
                <label className="switch-modern">
                  <input
                    type="checkbox"
                    name="usingApp"
                    checked={formData.usingApp}
                    onChange={handleChange}
                  />
                  <span className="slider-modern"></span>
                </label>
              </div>

              <div className="toggle-item-modal">
                <div className="toggle-label-group">
                  <span className="toggle-label-text">Status</span>
                  <span className={`toggle-status ${formData.status ? 'active' : 'inactive'}`}>
                    {formData.status ? 'Active' : 'Inactive'}
                  </span>
                </div>
                <label className="switch-modern">
                  <input
                    type="checkbox"
                    name="status"
                    checked={formData.status}
                    onChange={handleChange}
                  />
                  <span className="slider-modern"></span>
                </label>
              </div>
            </div>
          </div>

          <div className="modal-footer-modern">
            <button type="button" className="cancel-btn-modern" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="save-btn-modern">
              <Save size={16} />
              <span>Save Changes</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Model;
